import React, { useMemo, useState } from 'react';
import { WildcardDisplayNames, WildcardValues } from 'shared/enums/WildcardOptions';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';

interface IWildcardTagProps {
  value: WildcardValues;
  startIndex: number;
  previewMode: boolean;
  removeWildcard: (value: WildcardValues, startIndex: number) => void;
}

const WildcardTag = ({ value, startIndex, previewMode, removeWildcard }: IWildcardTagProps): JSX.Element | null => {
  const [isDeleted, setIsDeleted] = useState(false);

  const displayValue = useMemo(() => {
    const keyIndex = Object.values(WildcardValues).indexOf(value);
    const key = Object.keys(WildcardValues)[keyIndex];
    return WildcardDisplayNames[key as keyof typeof WildcardDisplayNames];
  }, [value]);

  const removeTag = (): void => {
    setIsDeleted(true);
    removeWildcard(value, startIndex);
  };

  return isDeleted ? null : (
    <Flex
      key={`wildcardTag_${startIndex}`}
      display="inline-flex"
      bg="background.lessSubtle"
      borderRadius="7px"
      fontWeight={600}
      fontSize={previewMode ? 'md' : 'xs'}
      width="fit-content"
      height="fit-content"
      py="1px"
      px={2}
      cursor="text"
      verticalAlign="bottom"
    >
      {!previewMode && (
        <Flex as="button" onClick={removeTag} alignSelf="center" mr={1} cursor="pointer">
          <Icon name="closeCircle" size="xs" variant="subtle" />
        </Flex>
      )}
      {displayValue}
    </Flex>
  );
};

export default WildcardTag;
